// Zerlegt ein Zeitfenster ({dateKey: performances[]}) in Bänder: Band i enthält
// die i-te Vorstellung jedes Tages (oder null). Jedes Band wird eine eigene
// Tabellenzeile mit vertical-align:top — so liegen die Uhrzeiten über alle
// Spalten auf einer Höhe, die Attribut-Textzeilen wachsen nach unten.
// Leeres Fenster liefert ein Null-Band, damit die Spacer-Zeile erhalten bleibt.
const buildPeriodBands = (performancesByDay) => {
  const perDay = Object.values(performancesByDay)
  const bandCount = Math.max(1, ...perDay.map(perfs => perfs.length))
  return Array.from({ length: bandCount }, (_, i) =>
    perDay.map(perfs => perfs[i] ?? null)
  )
}

export default buildPeriodBands
